import api from '@/services/api';

export default {
  async get(groupId, templateId) {
    try {
      let response = await api.get(`/Groups/${groupId}?templateId=${templateId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async update(groupData) {
    try {
      let response = await api.put('Groups', groupData);
      if (response && response.status == 200) {
        return { success: true, date: response };
      }
      return { success: false, data: (response && response.error) ? response.error : 'Unable to update group' };
    }
    catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  },
  async create(groupData) {
    try {
      let response = await api.post('Groups', groupData);
      if (response && response.status == 200) {
        return { success: true, date: response };
      }
      return { success: false, data: (response && response.error) ? response.error : 'Unable to create group' };
    }
    catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  },
  async delete(groupId, templateId) {
    try {
      let response = await api.delete(`/Groups/${groupId}?templateId=${templateId}`);
      if (response && response.status == 200) {
        return { success: true, data: response };
      }
      return { success: false, data: (response && response.error) ? response.error : 'Unable to delete group' };
    } catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  },
  async updateSortOrders(groups) {
    try {
      let response = await api.put('Groups/UpdateSortOrders', { groups: groups });
      if (response && response.status == 200) {
        return { success: true, date: response };
      }
      return { success: false, data: (response && response.error) ? response.error : 'Unable to update group sort orders' };
    }
    catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  }
}
